
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

const PUBLIC_ROUTES = ['/login', '/register', '/activate', '/forgot', '/reset'];

export default function RouteManager() {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isPublic = PUBLIC_ROUTES.includes(location.pathname);
    if (user) {
      // If authenticated and on public or not found, go to dashboard
      if (isPublic || location.pathname === '/404' || location.pathname === '/') {
        navigate('/dashboard', { replace: true });
      }
      // else stay on protected route
    } else {
      // Not authenticated
      if (!isPublic) {
        navigate('/login', { replace: true });
      }
    }
    // dispatch(setInit(true))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, location.pathname]);

  return <Outlet />;
}
